import * as React from 'react';
import type { SVGProps } from 'react';
const SvgArrowDropUp = (props: SVGProps<SVGSVGElement>) => <svg xmlns='http://www.w3.org/2000/svg' width='1em' height='1em' fill={props.fill} viewBox='0 0 20 20' {...props} data-sentry-element="svg" data-sentry-component="SvgArrowDropUp" data-sentry-source-file="ArrowDropUp.tsx">
    <path fill='#007AFF' d='M5.833 11.667 10 7.5l4.166 4.167z' data-sentry-element="path" data-sentry-source-file="ArrowDropUp.tsx" />
  </svg>;
export default SvgArrowDropUp;